<template>
  <div
    data-content
    :class="classList"
    @click="handleClick"
  >
    <div
      v-if="!separator && icon !== null"
      class="w-4 h-4 mr-2 relative"
    >
      <transition name="transition-fade">
        <vue-feather :type="icon"
                     v-if="icon !== '' && !loading"
                     data-icon
                     :class="classListIcon"></vue-feather>
      </transition>
      <transition name="transition-fade">
        <div
          v-if="icon === '' && !loading"
          data-icon
          :class="classListIcon"
        />
      </transition>
      <transition name="transition-fade">
        <Loader
          v-show="loading"
          data-loader
          visible
          class="absolute inset-0 z-20"
        />
      </transition>
    </div>
    <slot />
  </div>
</template>

<script>
import Loader from '@vuedir/components/Loader'

import VueFeather from 'vue-feather';

/**
 * MenuItem.vue
 */
export default {
  components: {
    Loader,
    VueFeather
  },

  props: {
    separator: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    selected: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {}
  },

  emits: ['click'],

  computed: {
    classList () {
      return [
        'transition-all cursor-pointer',
        this.separator ? 'border-t' : 'whitespace-nowrap p-4 flex items-center text-sm',
        !this.selected && this.disabled ? 'text-gray-300' : '',
        this.selected && !this.disabled ? 'hover:bg-gray-50 text-blue-500' : '',
        this.selected && this.disabled ? 'text-blue-200' : '',
        !this.selected && !this.disabled ? 'hover:bg-gray-50' : '',
      ]
    },

    classListIcon () {
      return [
        'w-4 h-4',
      ]
    },
  },

  methods: {
    handleClick () {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
  },
}
</script>
